import React, { Component } from 'react'
import { routes, asyncRoutes } from './router';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux'
import { setUserInfo, setAccesstoken, setExpires } from './redux/actions'
import { setTheme } from './redux/actions'

import {GlobalStyle} from '@/styles/globalStyle'
import { IconStyle } from '@/iconfont'
import { ThemeProvider } from 'styled-components'
import bwmodel from '@/config/bwmodel'
import bridge from '@/config/JSbridge'

import './App.css';

// import VConsole from 'vconsole';

class App extends Component {
   // eslint-disable-next-line 
  constructor(props) {
    super(props)
    this.state = {
      theme: 'light',
      userStatus: false
    }
  }

  async componentWillMount() {
    // new VConsole()
  
    bridge.addRegisterHandler([
      {
        name: 'refreshUserInfo',
        callback: (data, responseCallback) => {
          console.log(data, 'app notice token refresh');
          let params = data.params;
          this.props.setAccesstoken(params.accessToken);
          this.props.setExpires(params.expires);
        }
      }
    ]);

    bridge.callHandler('nativeEvent', {
      event: 'nativeControl',
      params: {
        navigation: {
          visibility: false
        },
        container: {},
        bottomToolbar: {
          visibility: false
        }
      }
    }, res => {})
    await this.props.setUserInfo()
    this.setState({userStatus: true})
    // this.changeTheme(bwmodel.theme === '1'? 'dark': 'light')
    this.setState({theme : bwmodel.theme === '1'? 'dark': 'light'})
    this.props.setTheme(bwmodel.theme === '1'? 'dark': 'light')
  }
 
  changeTheme = () =>{
    let theme = this.state.theme
    this.setState({theme : theme === 'light'? 'dark': 'light'})
    this.props.setTheme(theme === 'light'? 'dark': 'light')
  }
  render() {
    let customRoute = asyncRoutes.concat(routes)
    const theme = this.state.theme
    return (
      <div>
        {this.state.userStatus && 
        <ThemeProvider theme={{mode: theme}}>
          <GlobalStyle />
          <BrowserRouter>
            <IconStyle/>
            <Switch>
              {
                customRoute.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    render={(props) => {
                      if (route.children) {
                        return (
                          <div>
                            <route.component {...props} />
                            <Switch>
                              {
                                route.children.map((child, i) => (
                                  <Route
                                    key={i}
                                    path={child.path}
                                    exact={child.exact}
                                    component={child.component}
                                  />
                                ))
                              }
                              <Redirect to={route.children[0].path} />
                            </Switch>
                          </div>
                        )
                      } else {
                        return <route.component {...props} />
                      }
                    }}
                  />
                ))
              }
            </Switch>
          </BrowserRouter>
        </ThemeProvider>}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.user
})
const mapDispatchToProps = (dispatch) =>({
  setUserInfo: bindActionCreators(setUserInfo, dispatch),
  setAccesstoken: bindActionCreators(setAccesstoken, dispatch),
  setExpires: bindActionCreators(setExpires, dispatch),
  setTheme:  bindActionCreators(setTheme, dispatch),
})
export default connect(mapStateToProps, mapDispatchToProps)(App);
